import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { forgetUser } from '../../store/actions';
import logodark from "../../assets/images/logo.png";

const ForgetPasswordPage = ({ forgetUser, forgetError, message, loading }) => {
    const { handleSubmit, control, formState: { errors } } = useForm();

    useEffect(() => {
        document.body.classList.add("auth-body-bg");
        return () => {
            document.body.classList.remove("auth-body-bg");
        };
    }, []);

    const handleValidSubmit = (data) => {
        forgetUser(data);
    };

    return (
        <React.Fragment>
            <div>
                <div className="container-fluid p-0">
                    <div className="row g-0">
                        <div className="col-lg-4">
                            <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
                                <div className="w-100">
                                    <div className="row justify-content-center">
                                        <div className="col-lg-9">
                                            <div>
                                                <div className="text-center">
                                                    <div>
                                                        <Link to="/" className="logo"><img src={logodark} height="32" alt="logo" /></Link>
                                                    </div>
                                                    <h4 className="font-size-18 mt-4">Reset Password</h4>
                                                    <p className="text-muted">Reset your password to ValSabji.</p>
                                                </div>

                                                <div className="p-2 mt-5">
                                                    {forgetError && (
                                                        <div className="alert alert-danger mb-4">
                                                            {forgetError}
                                                        </div>
                                                    )}
                                                    {message && (
                                                        <div className="alert alert-success mb-4">
                                                            {message}
                                                        </div>
                                                    )}
                                                    <form onSubmit={handleSubmit(handleValidSubmit)}>
                                                        <div className="auth-form-group-custom mb-4">
                                                            <i className="ri-mail-line auti-custom-input-icon"></i>
                                                            <label htmlFor="useremail">Email</label>
                                                            <Controller
                                                                name="useremail"
                                                                control={control}
                                                                rules={{
                                                                    required: "Email is required",
                                                                    pattern: {
                                                                        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                                        message: "Invalid email address",
                                                                    }
                                                                }}
                                                                render={({ field }) => (
                                                                    <input
                                                                        {...field}
                                                                        type="email"
                                                                        id="useremail"
                                                                        placeholder="Enter email"
                                                                        className={`form-control ${errors.useremail ? "is-invalid" : ""}`}
                                                                    />
                                                                )}
                                                            />
                                                            {errors.useremail && (
                                                                <span className="text-danger">
                                                                    {errors.useremail.message}
                                                                </span>
                                                            )}
                                                        </div>

                                                        <div className="mt-4 text-center">
                                                            <button
                                                                className="btn btn-primary w-md waves-effect waves-light"
                                                                type="submit"
                                                            >
                                                                {loading ? "Loading..." : "Reset"}
                                                            </button>
                                                        </div>
                                                    </form>
                                                </div>

                                                <div className="mt-5 text-center">
                                                    <p>Don't have an account? <Link to="/login" className="fw-medium text-primary">Log in</Link></p>
                                                    <p>© 2021 ValSabji. Crafted with <i className="mdi mdi-heart text-danger"></i> by ValBeneti Ltd</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="authentication-bg">
                                <div className="bg-overlay"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

const mapStateToProps = (state) => {
    const { message, forgetError, loading } = state.Forget;
    return { message, forgetError, loading };
};

export default connect(mapStateToProps, { forgetUser })(ForgetPasswordPage);

